import React, { useEffect, useState } from 'react';
import styles from './scss/loginScreen.module.scss';
import logo from '../../../src/logo.svg';
import ForgotPassword from './forgetPassword';
import Signin from './Login';
import ResetLink from './resetPassword';
import { useHistory, useLocation } from 'react-router';
import { Cookie } from '../../base/utils';
import leftimg from '../../styles/images/new_login_image.png';
import jwt_decode from "jwt-decode";	
const Login =()=> {
  const [screen, setScreen] = useState<string>('login');
  const [email,setEmail] = useState<string>('');
  const [mount, setMount] = useState<boolean>(false);
  const history = useHistory();
  const location = useLocation();
  const updateLoginState = (state:string, email?:string) =>{
    setScreen(state);
    let Email = email?email:''
    setEmail(Email);  
  };

  useEffect(() => {
    document.title="Login to Worktual Web Application" 
    const pathData = location.pathname;
    const token:any =  Cookie.get();
    const ssoToken =  token["ssoToken"] ?? '';
    const decodedToken: any = ssoToken && jwt_decode(ssoToken);
    if(pathData==="/login" || pathData==="/"){
      if(!mount){
        const userInfo:any =Cookie.get();
        if(userInfo["ssoToken"] && decodedToken?.is_ucas_user === 1){
          setMount(true);
          history.push("/chats");
        }
      } else {
        Cookie.deleteKey("ssoToken");
      }
    }
  },[])
 
  return (
    <>
      <div className={styles.loginPage}>
        <div className={styles.headerRow}>
          <div className={styles.logoSec}>
            <img src={logo} alt="Header Logo" />
          </div>
          <div className={styles.closeIcon}>
            <span className="icon_close_line"></span>
          </div>
        </div>
        <div className={styles.contentSection}>
          <div className={styles.leftSection}>
          <img src={leftimg} alt="Header Logo" />
          </div>
          <div className={styles.signInSec}>
            {screen==="login" && <Signin updateState={updateLoginState} />}
            {screen==="forgot" && <ForgotPassword updateState={updateLoginState} email={email}/>}
            {screen==="reset" && email && <ResetLink email={email}  updateState={updateLoginState}/>}
            {/* <SetNewPassword /> */}
            {/* <ResetSuccess /> */}
            
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;